import React, { useState, useRef } from 'react';
import { Send } from 'lucide-react';
import emailjs from '@emailjs/browser';
import './ContactForm.css';

const ContactForm = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const result = await emailjs.sendForm(
        'service_ara3das', 
        'template_brvw9z6',
        form.current,
        'PfL3QsTk4pTUONQvR'
      );

      if (result.status === 200) {
        setStatus('success');
        form.current.reset();
      }
    } catch (error) {
      setStatus('error');
      console.log(error);
    }
    
    setLoading(false);
    setTimeout(() => setStatus(''), 5000);
  };

  return (
    <div className="p-8">
      <div className="container">
        <div className="form-wrapper">
          <h2 className="form-title">Contact Us</h2>
          
          <form ref={form} onSubmit={handleSubmit} className="contact-form">
            <div className="input-group">
              <input
                type="text"
                name="user_name"
                placeholder="Your Name"
                required
                className="input"
              />
            </div>
            
            <div className="input-group">
              <input
                type="email"
                name="user_email"
                placeholder="Your Email"
                required
                className="input"
              />
            </div>
            
            <div className="input-group">
              <input
                type="tel"
                name="user_phone"
                placeholder="Your Phone Number"
                required
                className="input"
                pattern="[0-9]{10}"
                title="Please enter a 10-digit phone number"
              />
            </div>
            
            <div className="input-group">
              <textarea
                name="message"
                placeholder="Your Message / Any enquiries or questions"
                required
                className="textarea"
              />
            </div>

            <button 
              type="submit" 
              disabled={loading}
              className="submit-btn"
            >
              {loading ? (
                'Sending...'
              ) : (
                <>
                  Send Message
                  <Send className="icon" />
                </>
              )}
            </button>

            {status === 'success' && (
              <div className="success-message">
                Thank you for your message! We'll get back to you soon.
              </div>
            )}

            {status === 'error' && (
              <div className="error-message">
                There was an error sending your message. Please try again later.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;